import { render, staticRenderFns } from "./AddDenomination.vue?vue&type=template&id=34190840&scoped=true&"
import script from "./AddDenomination.vue?vue&type=script&lang=js&"
export * from "./AddDenomination.vue?vue&type=script&lang=js&"
import style0 from "./AddDenomination.vue?vue&type=style&index=0&id=34190840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34190840",
  null
  
)

export default component.exports